module.exports = __webpack_public_path__ + "static/media/orientacoes_documentos.fcd828a2.txt";